var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tortchart"},[_c('div',{style:({height:'357px',paddingTop:'10px',width:'100%'}),attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }